export default __webpack_public_path__ + "static/image2-f3a4393d0b197aa23e23e15e9eb0f31c.jpeg";